import {
  GET_ALL_SUMMARIES,
  GET_ALL_SUMMARIES_SUCCESS,
  GET_ALL_SUMMARIES_FAIL,
  GET_SUMMARY_DETAILS,
  GET_SUMMARY_DETAILS_SUCCESS,
  GET_SUMMARY_DETAILS_FAIL,
  CREATE_SUMMARY,
  CREATE_SUMMARY_SUCCESS,
  CREATE_SUMMARY_FAIL,
} from "./actionTypes"

// Summary - This line cannot be edited or removed
export const getAllSummaries = (page, limit, searchText, filters) => ({
  type: GET_ALL_SUMMARIES,
  payload: {
    page,
    limit,
    searchText,
    filters,
  },
})

export const getAllSummariesSuccess = summaries => ({
  type: GET_ALL_SUMMARIES_SUCCESS,
  payload: summaries,
})

export const getAllSummariesFail = error => ({
  type: GET_ALL_SUMMARIES_FAIL,
  payload: error,
})

export const getSummaryDetails = summaryId => ({
  type: GET_SUMMARY_DETAILS,
  payload: summaryId,
})

export const getSummaryDetailsSuccess = summaryDetails => ({
  type: GET_SUMMARY_DETAILS_SUCCESS,
  payload: summaryDetails,
})

export const getSummaryDetailsFail = error => ({
  type: GET_SUMMARY_DETAILS_FAIL,
  payload: error,
})

export const createSummary = (summary, onCloseClick) => ({
  type: CREATE_SUMMARY,
  payload: { summary, onCloseClick },
})

export const createSummarySuccess = summary => ({
  type: CREATE_SUMMARY_SUCCESS,
  payload: summary,
})

export const createSummaryFail = error => ({
  type: CREATE_SUMMARY_FAIL,
  payload: error,
})
